import React from 'react'
import { useIntl } from 'react-intl'

import Toggle from 'src/comps/Atom/ToggleIcon'

import { PhotosCategoriesBase } from './styles'

interface Categories {
  id: string
  count: number
  text: string
}

interface Props {
  categories: Categories[]
  onCategoryClick: (category: string) => void
  selectedCategory: string
}

const PhotosCategories = ({ categories, onCategoryClick, selectedCategory }: Props) => {
  const intl = useIntl()

  return (
    <PhotosCategoriesBase>
      {categories.map(
        category =>
          category.count > 0 && (
            <Toggle
              key={category.id}
              onChange={() => onCategoryClick(category.id)}
              initialValue={selectedCategory === category.id}
            >
              {`${intl.formatMessage({ id: category.text })} (${category.count})`}
            </Toggle>
          )
      )}
    </PhotosCategoriesBase>
  )
}

export default PhotosCategories
